//!function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},r.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=51)}({51:function(e,t,r){"use strict"}});

// this version's change compared with 110119 - this includes js for show/hide header

//PAGE JS
$(document).ready(function(){

  $('#menu-trigger').prop('checked',false);
  $('.next-trigger-check').prop('checked',false);
  
  //smooth scroll for anchors
  $('.smoothscroll').click(function(event) {
    event.preventDefault();// commented so links work from different pages...
    var target = this.hash;
    var windowWidth = $window.width();
    if ($window.width() < 1000) {
        // var navHeight = 60;
        var navHeight = 0;
    } else {
        // var navHeight = 90;
        var navHeight = 0;
    }
    $('html,body').stop().animate( { scrollTop:$(target).offset().top - navHeight } , 1000);
    $(this).blur();

    if ($(this).hasClass('show-hide')) {
        var targetPanel = $(target).find('.show_more');
        if ($(targetPanel).hasClass('hide')) {
            $(targetPanel).click().blur();
        }
    }
  });

  //generic show/hide 
  if ($('.show_more').length > 0) {

    $('.more_content').hide();

    $(".show_more").click(function() {
        $(this).toggleClass('hide show');
        $(this).next('.more_content').toggleClass('hide show').slideToggle();
    });
  }
    
  headerHeight = $('header.big').outerHeight();
//   var announcementHeight = $('.announcement').outerHeight();
  topHeight = headerHeight;
//   var annHeight = $('.announcement').outerHeight();

    // Cached window jQuery object
    var $window = $(window);

    // Store the window width
    var windowWidth = $window.width();
    var viewportHeight = $window.height();

    function setMobileNavHeight() {
        
        if ($window.width() < 1000) {
            if ($('body').hasClass('mobile-nav-open')) {
                $('nav.first.mobile').css("height", (viewportHeight - topHeight));
                $('.nav-holder').css("height", (viewportHeight - topHeight));
            } else {
                $('nav.first.mobile').css("height", 'auto');
                $('.nav-holder').css("height", 'auto');
            } 
        } else {
            $('nav.first.mobile').css("height", 'auto');
            $('.nav-holder').css("height", 'auto');
        }
    }

    // function setMainPadding() {
    //     $('main').css("padding-top", topHeight);
    // }
    // setMainPadding();

    function setHeaderHeight() {
        $('.header-holder').css("height", topHeight);
        $('header.big').css({position : 'fixed'})
    }
    setHeaderHeight();

    $(window).on("resize",function() {
        
        setTimeout(function(){
            topHeight = headerHeight;
            viewportHeight = $window.height();
            setMobileNavHeight();
            
        },700);

        setTimeout(function(){
            headerHeight = $('header.big').outerHeight();
            topHeight = headerHeight;
            
            //check 'resize' isn't just iOS scroll
            if ($window.width() != windowWidth) {
                // Update the window width for next time
                windowWidth = $window.width();
                // setMainPadding();
                setHeaderHeight();
            }
        },700);//can't be less than this else doesn't update on orientation change (iPad)
    });

    //search toggle 
    // $('#search-toggle').click(function(e) {

    //     if ($('body').hasClass('nav-open')) {
    //         $(".nav-active").click().blur();
    //     }

    //     if ($('body').hasClass('mobile-nav-open')) {
    //         $('#menu-trigger').click().blur();
    //     }
 
    //     $('#show-search').toggleClass('closed open');
    //     $('body').toggleClass('search-closed search-open');

    //     if ($('#show-search').hasClass('open')) {
    //         if ( $('.search__input').length > 0 ) {
    //             $('.search__input').focus();
    //         }
            
    //         if ( $('input.boost-pfs-search-box').length > 0 ) {
    //             $('input.boost-pfs-search-box').focus();
    //         }
    //     }
    // });


//   $(window).bind('scroll', { passive: true }, function(){
//     //   if ($(window).scrollTop() < topHeight) {
//     //     $('.announcement').addClass('visible').removeClass('invisible');
//     //     // $('header.big').addClass('top').removeClass('scrolled');
//     //   } else {
//     //     $('.announcement').addClass('invisible').removeClass('visible');
//     //     // $('header.big').addClass('scrolled').removeClass('top');
//     //   }

//       if ($(window).scrollTop() < 10 ) {
//         setTimeout(function(){
//             headerHeight = $('header.big').outerHeight();
//             topHeight = headerHeight;
//             // setMainPadding();
//             setHeaderHeight();
//         }, 200);
//       }
//   });  


// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var headerHeight = $('header').outerHeight();
var navbarHeight = (headerHeight);
// var navbarHeight = 1;

$(window).on('scroll', function() {
    didScroll = true;
    // $('.boost-pfs-search-suggestion-wrapper').hide();
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 100);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make sure they scroll more than delta/threshold to show actual intent (not just a couple of px wobble either way)
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
        
    if (st > lastScrollTop && st > navbarHeight){
    // if (st > lastScrollTop && st > navbarHeight){
    // Scroll Down

        // console.log('scroll down');
        
        //don't hide if mega/search are open (can assume being used)
        if (! $('.mega').hasClass('open') && ! $('.search').hasClass('open')) {
            $('header').removeClass('nav-show').addClass('nav-hide');
        }
        
        if ($('.boost-pfs-filter-tree-h-sticky-filter').length > 0 || $('.boost-pfs-filter-stick-body').length > 0) {
            // console.log('scroll down got class');
            $('.boost-pfs-filter-tree-h-sticky-filter .boost-pfs-filter-wrapper').css('top', 0);
            $('.boost-pfs-filter-tree-mobile-button-stick-wrapper .boost-pfs-filter-toolbar-top-mobile-inner').css('top', 0);
        }

        // setTimeout(function(){
        //     // headerHeight = $('header.big').outerHeight();
        //     topHeight = headerHeight;
        //     setHeaderHeight();
        // }, 400);

    } else {
        

        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('header').removeClass('nav-hide').addClass('nav-show');
            // console.log('scroll-up');

            if ($('.boost-pfs-filter-tree-h-sticky-filter').length > 0 || $('.boost-pfs-filter-stick-body').length > 0) {
                // console.log('scroll-up got class');
                scrolledHeaderHeight = $('header.main').outerHeight();
                $('.boost-pfs-filter-tree-h-sticky-filter .boost-pfs-filter-wrapper').css('top', scrolledHeaderHeight);
                $('.boost-pfs-filter-tree-mobile-button-stick-wrapper .boost-pfs-filter-toolbar-top-mobile-inner').css('top', scrolledHeaderHeight);
            }
        }

        // if (st < (navbarHeight)){
        //     setTimeout(function(){
        //         topHeight = 0;
        //         setHeaderHeight();
        //         console.log('edit');
        //     }, 0);
        // }

        // setTimeout(function(){
        //     headerHeight = $('header.big').outerHeight();
        //     topHeight = headerHeight;
        //     setHeaderHeight();
        // }, 400);
    } 
        
    lastScrollTop = st;

    if ($(window).scrollTop() < navbarHeight) {
        $('header.big').addClass('top').removeClass('scrolled');
        // $('.header-holder').addClass('top').removeClass('scrolled');

        // setTimeout(function(){
        //     headerHeight = $('header.big').outerHeight();
        //     topHeight = headerHeight;
        //     setHeaderHeight();
        // }, 400);

        // if ($(window).scrollTop() < navbarHeight) {
        //     $('header.big').addClass('top').removeClass('scrolled');
        //   } else {
        //     $('header.big').addClass('top').removeClass('scrolled');
        //   }
      } else {
        $('header.big').addClass('scrolled').removeClass('top');
        // $('.header-holder').addClass('scrolled').removeClass('top');

        // setTimeout(function(){
        //     headerHeight = $('header.big').outerHeight();
        //     topHeight = headerHeight;
        //     setHeaderHeight();
        // }, 400);
      }
}

  
    $('#menu-trigger').click(function(e) {
        $('body').toggleClass('mobile-nav-closed mobile-nav-open');
        setMobileNavHeight();
        
        // if ($('body').hasClass('search-open')) {
        //     $("#search-toggle").click().blur();
        // }
    });
    

    $('.desktop [data-mega-id]').click(function(e) {
        //close search
        // if ($('body').hasClass('search-open')) {
        //     $("#search-toggle").click().blur();
        // }

        var megaHolder = $(this).attr('data-mega-id');
        var clicked = $(this).attr('data-mega-id');
        var match = 'article#'+clicked;

        // if no megas open
        if (! $('.mega').hasClass('open')) {
            //FIRST OPEN
            // console.log('toggle open');
            $(this).addClass('nav-active');
            $(this).closest('header.main').find('#'+megaHolder).removeClass('closed').addClass('open');
            $('header.main').removeClass('closed').addClass('open');
            $('body').removeClass('nav-closed').addClass('nav-open');
            $('main').removeClass('nav-closed').addClass('nav-open');
            $('footer').removeClass('nav-closed').addClass('nav-open');

        } else { // if any megas open

            // if this mega is open
            if ($(match).hasClass('open')) {
                //CLOSE CURRENT
                // console.log('toggle closed');
                $(this).removeClass('nav-active');
                $(match).removeClass('open').addClass('closed');
                $('header.main').removeClass('open').addClass('closed');
                $('body').removeClass('nav-open').addClass('nav-closed');
                $('main').removeClass('nav-open').addClass('nav-closed');
                $('footer').removeClass('nav-open').addClass('nav-closed');

            } else { // if another mega is open
                //CLOSE CURRENT, OPEN NEW
                // console.log('switch');
                $('.mega').removeClass('open').addClass('closed');
                $('li a').removeClass('nav-active');

                $(this).addClass('nav-active');
                $(this).closest('header.main').find('#'+megaHolder).removeClass('closed').addClass('open');
            }
        }
    });  

    $(".scroller-inner").click(function() {
        if ($('body').hasClass('nav-open')) {
            $(".nav-active").click().blur();
        }
    });


  //subscribe
    $('#newslettersubscribe .btn_showmore').click(function(e) {
        $(this).addClass('hide').removeClass('show');
        $(this).parents('.email_fieldholder').siblings('.extendform').slideDown().addClass('show').removeClass('hide');
        $('#newslettersubscribe .email_fieldholder').addClass('extended');
    });


  var $form = $('#mc-embedded-subscribe-form');
    if ( $form.length > 0 ) {
      $('#newssubscribe').bind('click', function ( event ) {
        if ( event ) event.preventDefault();
        if ( validateNewsletter($form) ) { register($form);
      }
    });
  }

  //account – change password toggle
    if ($('#change-password').length > 0) {
        $('#change-password').hide();

        $('.account-details ul span').click(function() {
            var match = $(this).attr('data-id');
            $('#' + match).slideToggle();
        });
    }

});//END READY


//subscribe setup
// function register($form) {
//     $.ajax({
//         type: $form.attr('method'),
//         url: $form.attr('action'),
//         data: $form.serialize(),
//         cache       : false,
//         dataType    : 'json',
//         contentType: "application/json; charset=utf-8",
//         error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
//         success     : function(data) {
//             if (data.result != "success") {
//                 $('#newslettererror').html(data.msg);
//                 $('#newslettererror').slideDown();
//             } else {
//                 $('#newslettersubscribe').hide();
//                 $('#newslettersubscribed').show();
//             }
//         }
//     });
// }
// function validateNewsletter($form) {
//   var email = $('#mail').val();
// //   var tdate = $('#newsday').val();
// //   var tmonth = $('#newsmonth').val();

//   var filter = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
// //   var monthfilter = /^(0[1-9]|1[0-2])$/;
// //   var dayfilter = /^(0[1-9]|[12]\d|3[01])$/;
  
//   if (filter.test(email)) 
//   {
//   $('#newslettererror').hide();
//   } 
//   else
//   {
//   $('#newslettererror').slideDown();
//   }

// //   if (dayfilter.test(tdate)) 
// //   {
// //   $('#newsletterbirthdayerror').hide();
// //   } 
// //   else
// //   {
// //   $('#newsletterbirthdayerror').slideDown();
// //   }
  
// //   if (monthfilter.test(tmonth)) 
// //   {
// //   $('#newsletterbirthdayerror').hide();
// //   } 
// //   else
// //   {
// //   $('#newsletterbirthdayerror').slideDown();
// //      console.log('month');
// //   }

// //   if ( (filter.test(email)) && (dayfilter.test(tdate)) && (monthfilter.test(tmonth)))
// if ( (filter.test(email)) )
//   {
//    return true; 
//   }
//   else
//   {
//     return false;
//   }

// }


